import getuser from "../aws_utils/getAuthuser";
import { fetchAPI } from "../lib/fetch";

// Provide Auth
export const getUser = async (sub: string, auth: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  // console.log("auth", auth);
  try {
    const user = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        id: sub,
      }),
    });

    return user;
  } catch (error: any) {
    // console.log("error from mongocall getUser", error);
    // console.log("get user error hit", error);
    // Expired Token Error
    if (
      error.response &&
      error.response.data &&
      error.response.data === "token expired"
    ) {
      return "refresh token";
    }
    return null;
  }
};

export const addUser = async (
  username: string,
  email: string,
  sub: string,
  stripeid: string
) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/users`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const addUserRes = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        username: username,
        email: email,
        sub: sub,
        stripeid: stripeid,
      }),
    });

    return addUserRes;
  } catch (error) {
    // console.log("error from mongocall addUser", error);
    return null;
  }
};

// Provide Auth
export const getProjects = async (auth: string) => {
  const currentuser = await getuser();
  const userid = currentuser.username;
  const awsServiceUrl = `${process.env.REACT_APP_GW}/projects`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const projects = await fetchAPI(awsServiceUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
        "x-api-key": awsKey,
      },
      params: {
        id: userid,
      },
    });

    // console.log("Projects", projects);
    return projects as [];
  } catch (error: any) {
    // console.log("error", error);
    if (
      error.response &&
      error.response.data &&
      error.response.data === "token expired"
    ) {
      return "refresh token";
    }
    return [];
  }
};

export const addProject = async (userid: string, projectname: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/projects`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const addProjectRes = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      params: {
        userid: userid,
        projectname: projectname,
      },
    });

    // console.log("Projects", projects);
    return addProjectRes;
  } catch (error) {
    return error;
  }
};

export const deleteProjectAndChats = async (
  userid: string,
  projectname: string
) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/projects`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const deleteRes = await fetchAPI(awsServiceUrl, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      params: {
        userid: userid,
        projectname: projectname,
      },
    });

    // console.log("Projects", projects);
    return deleteRes;
  } catch (error) {
    return error;
  }
};

// Provide Auth
export const getProjectChats = async (projectName: string, auth: string) => {
  const currentuser = await getuser();
  const userid = currentuser.username;
  const awsServiceUrl = `${process.env.REACT_APP_GW}/chats`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  if (auth === undefined) {
    // console.log("auth?", auth);
    return [];
  }

  try {
    const projectChats = await fetchAPI(awsServiceUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
        "x-api-key": awsKey,
      },
      params: {
        userId: userid,
        project: projectName,
      },
    });
    return projectChats;
  } catch (error: any) {
    // console.log("get project chats error hit", error);
    // Expired Token Error
    if (
      error.response &&
      error.response.data &&
      error.response.data === "token expired"
    ) {
      return "refresh token";
    }
    return [];
  }
};

export const addProjectChat = async (addChatPackage: {
  project: string;
  userId: string;
  query: string;
  response: string;
  agent: string;
  image?: boolean;
  images?: any; // Vision
  image_url?: any;
}) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/chats`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify(addChatPackage),
    });
    return true;
  } catch (error) {
    return error;
  }
};

export const deleteProjectChat = async (chatid: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/chats`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    await fetchAPI(awsServiceUrl, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      params: {
        chatid: chatid,
      },
    });

    alert("Chat successfully deleted!");
    return true;
  } catch (error) {
    console.log("error from delete chat");
    return false;
  }
};
